import React from 'react';
import ArtifactImage from './ArtifactImage.png';

export const ArtifactCardIllustration: React.FC = () => (
  <img
    src={ArtifactImage}
    alt="Artifact preview"
    style={{
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    }}
  />
);
